/**
 * Ícone simplificado das bandeiras de cartão (SVG inline, sem dependência externa).
 * Uso: <BandeiraIcone bandeira="Visa" /> — sem bandeira ('' ou desconhecida) mostra um cartão genérico.
 */
import React from 'react';
import CreditCardIcon from '@mui/icons-material/CreditCard';

const FUNDOS = {
  Visa: '#1A1F71',
  Mastercard: '#FFFFFF',
  Elo: '#000000',
  'American Express': '#016FD0',
  Hipercard: '#B3131B',
};

const texto = { fontFamily: 'Arial, Helvetica, sans-serif', fontWeight: 700, textAnchor: 'middle', fill: '#fff' };

function Marca({ bandeira }) {
  switch (bandeira) {
    case 'Visa':
      return <text x="24" y="20.5" fontSize="13" fontStyle="italic" letterSpacing="0.5" {...texto}>VISA</text>;
    case 'Mastercard':
      return (
        <>
          <circle cx="19" cy="15" r="8" fill="#EB001B" />
          <circle cx="29" cy="15" r="8" fill="#F79E1B" />
          <path d="M24 8.8a8 8 0 0 1 0 12.4 8 8 0 0 1 0-12.4z" fill="#FF5F00" />
        </>
      );
    case 'Elo':
      return (
        <>
          <text x="24" y="21" fontSize="12" {...texto}>elo</text>
          <circle cx="16" cy="9" r="1.8" fill="#FFCB05" />
          <circle cx="24" cy="9" r="1.8" fill="#00A4E0" />
          <circle cx="32" cy="9" r="1.8" fill="#EF4123" />
        </>
      );
    case 'American Express':
      return <text x="24" y="19.5" fontSize="9.5" letterSpacing="0.3" {...texto}>AMEX</text>;
    case 'Hipercard':
      return <text x="24" y="18.5" fontSize="7.2" {...texto}>Hipercard</text>;
    default:
      return null;
  }
}

export default function BandeiraIcone({ bandeira, largura = 32 }) {
  if (!FUNDOS[bandeira]) return <CreditCardIcon sx={{ fontSize: largura * 0.7 }} />;
  return (
    <svg
      width={largura} height={largura * 0.625} viewBox="0 0 48 30" role="img" aria-label={bandeira}
      style={{ display: 'block', flexShrink: 0 }}
    >
      <rect x="0.5" y="0.5" width="47" height="29" rx="4.5" fill={FUNDOS[bandeira]} stroke="rgba(0,0,0,0.18)" />
      <Marca bandeira={bandeira} />
    </svg>
  );
}
